







































































import Vue from 'vue';

export default Vue.extend({
  name: 'Boy',
  props: {
    isSelected: Boolean,
  },
});
